import memory from "./images/projects/memory.png";
import portfolio from "./images/projects/portfolio.png";
import flixer from "./images/projects/flixer.png";
import whatsapp from "./images/projects/whatsapp.png";
import portfolio2 from "./images/projects/portfolio2.png";
import matrixroute from "./images/projects/matrixroute.png";
import moderncv from "./images/projects/moderncv.png";
import minecraft from "./images/projects/minecraft.png";
import docs from "./images/projects/docs.png";
import zoom1 from "./images/projects/vc.png";
import shareme from "./images/projects/shareme.png";

export const projectData = [
  {
    title: "Bloack Land Baba",
    description: `3D Web App App where you can traverse the city and chat with other users.
    Three Js:Three.js is a cross-browser JavaScript library and application programming interface used to create and display 
    animated 3D computer graphics in a web browser using WebGL. The source code is hosted in a repository on GitHub.`,
    technologies: "HTML, Javascript, Three JS, Socket IO, FBX Loader, Cannon JS, Blender, Heroku, Github",
    image: moderncv,
    date_created: "Jan 2022",
    link: "https://precious-galoshes-bear.cyclic.app/",
    github: "https://github.com/Thakur-Sahab-4-5-2000/Blockland",
  },
  {
    title: "Flixer",
    description: `Flixer is a clone of Netflix's web interface. This app was created using React 
    functional components, Redux state management, axios async/await requests, and deployed on Google Firebase. 
    Firebase Authentication allows user account creation, and Firebase Firestore is the database used to store 
    customer and product records. Additional functionality includes customer subscription checkout powered by 
    the Stripe Firebase Extension and Stripe API integration. Once a user is subscribed, movie data is pulled 
    from The Movie Database (TMDB) for trending movies and movie poster images. Movie trailers are integrated 
    from YouTube if one is successfully found.`,
    technologies:
      "React, Redux, Stripe API, Firebase Authentication, Firebase Firestore, JavaScript, HTML, CSS, GitHub",
    image: flixer,
    date_created: "February 2021",
    link: "https://flix-97e6f.web.app/profile",
    github: "https://github.com/PahariBande/Flixer",
    test_user: "test@test.com",
    test_password: "abc123",
    cc: {
      number: "4242 4242 4242 4242",
      expiration: "04/24",
      cvv: "424",
      billing: "Anything",
    },
  },
  {
    title: "Memory APP",
    description: `This is app was created using React, Node.js, Express & MongoDB you'll learn how to build a Full Stack MERN Application - from start to finish. The App is called "Memories" and it is a simple social media app that allows users to post interesting events that happened in their lives.`,
    technologies:
      "React, NodeJS, JavaScript, HTML, CSS, GitHub, Netlify,Heroku",
    image: memory,
    date_created: "June 2021",
    link: "https://shubbu-memmory.netlify.app",
    github: "https://github.com/PahariBande/Memory--App",
  },
  {
    title: "Portfolio",
    description: `This portfolio was created using React. The inspiration for the theme
        was based on 80's retro arcade games. The site is mobile and desktop responsive, with
        additional functionality including an app-wide music player that is saved in the app state. `,
    technologies: "React, JavaScript, HTML, CSS, GitHub, Netlify",
    image: portfolio,
    date_created: "May 2021",
    link: "https://shubbu-portfolio.netlify.app",
    github: "https://github.com/PahariBande/Portfolio",
  },
  {
    title: "Whats-App 2",
    description: `Whats App 2 is written in Next js production framework of react there is 1-1 chat feature avaialble in this is application,you can sign in application using google authentication.
    Next js features:By default, Next.js pre-renders every page. This means that Next.js generates HTML for each page in advance, instead of having it all done by client-side JavaScript. Pre-rendering can result in better performance and SEO.`,
    technologies: "Next Js, JavaScript, HTML, CSS, GitHub,Vercel",
    image: whatsapp,
    date_created: "July 2021",
    link: "https://whats-app2-p0yp0zxb0-thakursaahab.vercel.app",
    github: "https://github.com/PahariBande/WhatsApp2",
  },
  {
    title: "3D Portfolio",
    description: `3D Scrolling Portfolio Website with Three.js.
    Three Js info:Three.js is a cross-browser JavaScript library and application programming interface used to create and display animated 3D computer graphics in a web browser using WebGL. `,
    technologies: "Vite, JavaScript, HTML, CSS, GitHub,Netlify",
    image: portfolio2,
    date_created: "July 2021",
    link: "https://shubbu-threejs.netlify.app",
    github: "https://github.com/PahariBande/Three-js",
  },
  {
    title: "Matrix Route",
    description: `Matrix Router made using TOM TOM APi.
    Matrix Route App is basically based on the idea of Dijkstra's shortest path algorithm how a delivery boy can reach the different spots through shortest distance in short time`,
    technologies: "React,Javascript,HTML,CSS,TOM TOM API,Github,Netlify",
    image: matrixroute,
    date_created: "May 2021",
    link: "https://matrixroute.netlify.app/",
    github: "https://github.com/PahariBande/MatrixRoutingAPP",
  },
  {
    title: "MineCraft Clone",
    description: `MineCraft made using Threejs and React.
    Currently it has 5 types of blocks: Grass, Wood, Log, Glass and Dirt. You switch blocks with numbers 1-5 on your keyboard. You navigate the world with the mouse and WASD. You can click to add blocks and Q+Click to remove blocks. You world is stored in your browsers local storage.`,
    technologies: "React,Javascript,HTML,CSS,React Three Fiber,Use Cannon,Github,Netlify",
    image: minecraft,
    date_created: "July 2021",
    link: "https://shubbu-minecraft.netlify.app",
    github: "https://github.com/PahariBande/Minecrat-Clone",
  },
    {
    title: "G-DOCS Clone",
    description: `GOOGLE DOCS Clone made using Next.js, Rich Text Editor, Tailwind CSS & Firebase.
    GOOGLE DOCS build using functionality like NextAuth,Firebase,Rich Text Editor:RichTextEditor is the main editor component. It is comprised of the Draft.js <Editor>, some UI components (e.g. toolbar) and some helpful abstractions around getting and setting content with HTML/Markdown.
    RichTextEditor is designed to be used like a textarea except that instead of value being a string, it is an object with toString on it. Creating a value from a string is also easy using createValueFromString(markup, 'html').`,
    technologies: "Next.js,Rich Text Editor,draft JS,Tailwind CSS,Firebase,Github,Vercel",
    image: docs,
    date_created: "July 2021",
    link: "https://google-docs-beta.vercel.app",
    github: "https://github.com/PahariBande/GoogleDocs",
  },
    {
    title: "Zoom Clone",
    description: `Zoom Clone made using React.js, Socket IO, Express,WebRTC.
    WebRTC is a free and open-source project providing web browsers and mobile applications with real-time communication via simple application programming interfaces`,
    technologies: "React,Javascript,Nodejs,Socket IO,Express,WebRTC",
    image: zoom1,
    date_created: "July 2021",
    link: "https://shubbuzoom.netlify.app/",
    github: "https://github.com/PahariBande/ZoomClone1",
  },
  {
    title: "Share Me",
    description: `ShareMe is made using React.js,TailWind CSS,Sanity Io.
    Sanity.io is the platform for structured content. With Sanity.io you can manage your text, images, and other media with APIs. You can also use the open-source single page application Sanity Studio to quickly set up an editing environment that you can customize. With Sanity.io you have access to a bunch of APIs, libraries, and tooling that helps you leverage the benefits of having all your content available as a single source of truth. This article will quickly walk you through some central concepts, giving you a head start.`,
    technologies: "React,Javascript, TailWind CSS, Sanity IO, Axios",
    image: shareme,
    date_created: "December 2021",
    link: "https://shubbu-shareme.netlify.app/",
    github: "https://github.com/PahariBande/Share-Me",
  },
 ];
